module.exports = __webpack_public_path__ + "./Winnie_4becec0e009d5814730ad795817d9fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Winnie.jpg
// module id = 580
// module chunks = 0